import React from "react";
import { Search, X } from "lucide-react";

const SEARCH_TABS = new Set(["calendar", "crm", "ops", "vendors", "sales_manager"]);
const SEARCH_LABELS = { calendar: "bookings", crm: "customers", ops: "ops team", vendors: "vendors", sales_manager: "leads" };

const AdminSearchBar = ({ activeTab, searchQuery, setSearchQuery, statusFilter, setStatusFilter, dateFrom, setDateFrom, dateTo, setDateTo }) => {
  if (!SEARCH_TABS.has(activeTab)) return null;
  return (
  <div className="flex flex-wrap items-center gap-3 mb-6" data-testid="admin-search-bar">
    <div className="flex-1 min-w-[200px] relative">
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94a3b8]" />
      <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
        placeholder={`Search ${SEARCH_LABELS[activeTab] || activeTab}...`}
        className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#DC283C] focus:ring-2 focus:ring-[#DC283C]/20 outline-none text-sm"
        data-testid="admin-search-input" />
    </div>
    {activeTab === "calendar" && (
      <>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}
          className="px-3 py-2.5 rounded-xl border border-gray-200 focus:border-[#DC283C] outline-none text-sm text-[#475569]"
          data-testid="admin-status-filter">
          <option value="all">All Status</option>
          <option value="pending">Pending</option>
          <option value="confirmed">Confirmed</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
        <div className="flex items-center gap-2">
          <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)}
            className="px-3 py-2 rounded-xl border border-gray-200 focus:border-[#DC283C] outline-none text-sm text-[#475569]"
            data-testid="admin-date-from" placeholder="From" />
          <span className="text-[#94a3b8] text-sm">to</span>
          <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)}
            className="px-3 py-2 rounded-xl border border-gray-200 focus:border-[#DC283C] outline-none text-sm text-[#475569]"
            data-testid="admin-date-to" placeholder="To" />
        </div>
      </>
    )}
    {(searchQuery || dateFrom || dateTo || statusFilter !== "all") && (
      <button onClick={() => { setSearchQuery(""); setDateFrom(""); setDateTo(""); setStatusFilter("all"); }}
        className="flex items-center gap-1 px-3 py-2 text-sm text-[#DC283C] hover:bg-[#DC283C]/5 rounded-xl transition-colors"
        data-testid="clear-filters-btn">
        <X size={14} /> Clear
      </button>
    )}
  </div>
  );
};

export default AdminSearchBar;
